export default {
  meta: {
    title: '处理采购任务'
  }
};
